const RECONNECT_BASE_MS = 2000;
const RECONNECT_MAX_MS = 30000;

let ws = null;
let reconnectTimer = null;
let reconnectAttempt = 0;
let stopped = true;

function wsURL() {
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}/api/ws/presence`;
}

function clearReconnect() {
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
}

function scheduleReconnect() {
  if (stopped) return;
  clearReconnect();
  const delay = Math.min(RECONNECT_BASE_MS * 2 ** reconnectAttempt, RECONNECT_MAX_MS);
  reconnectAttempt += 1;
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null;
    connect();
  }, delay);
}

function connect() {
  if (stopped) return;

  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
    return;
  }

  try {
    ws = new WebSocket(wsURL());
  } catch {
    scheduleReconnect();
    return;
  }

  ws.onopen = () => {
    reconnectAttempt = 0;
  };

  ws.onclose = () => {
    ws = null;
    if (!stopped) {
      scheduleReconnect();
    }
  };

  ws.onerror = () => {
    // onclose 会随后触发并负责重连
  };
}

function disconnect() {
  clearReconnect();
  if (ws) {
    const sock = ws;
    ws = null;
    sock.onclose = null;
    sock.onerror = null;
    sock.onopen = null;
    try {
      sock.close();
    } catch {
      /* ignore */
    }
  }
}

/** 打开页面即建立 presence WebSocket，按连接数统计在线；关页或主动 stop 时断开。 */
export function initPresence() {
  if (typeof window === 'undefined') return () => {};
  stopped = false;
  connect();
  return () => {
    stopped = true;
    disconnect();
  };
}
